import { rem } from 'polished';
import styled from 'styled-components';
import { mediaQueryWidth } from '../../common/breakpoints';
import { StyledCard } from '../../components/card/Card.styles';

export const StyledCompanyLayout = styled.section``;

export const StyledCompanyCards = styled.div`
  padding-top: ${rem(40)};

  & > ${() => StyledCard}:not(:last-of-type) {
    padding-bottom: ${rem(30)};

    ${mediaQueryWidth({ min: 'tablet' })`
      padding-bottom: ${rem(36)};
    `}
  }
`;
